import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import App from './App';
import Maintenance from './components/Maintenance';
import { installKeyboardActivation } from './config/keyboardActivation';
import { installApiClient } from './api/client';
import reportWebVitals from './reportWebVitals';

import Loader from './components/Loader/Loader'


const ALL_NAMESPACES = ['account', 'activation_banner', 'affiliates', 'analytics', 'analytics_v2', 'analytics_advanced', 'analytics_plus', 'analytics_simple', 'authorizations', 'calendar', 'cancellation', 'composer', 'content_ai', 'countries_FB', 'custom_scheduler', 'dashboard', 'email_conf', 'engage', 'faq', 'feeds', 'footer', 'header', 'issues', 'library', 'limitation_banner', 'maintenance', 'manage', 'media_checker', 'new_post', 'news', 'onboarding', 'onboarding_cesam', 'plans', 'plans_CESAM', 'plans_advanced', 'post_list', 'pricingTableMDN', 'reset_pwd', 'settings', 'sidebar', 'signin', 'team_clients', 'signup', 'smlink', 'third_party', 'upgrade', 'welcome', 'whats_new'];

installKeyboardActivation();
installApiClient();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ['en', 'fr'],
    fallbackLng: "en",
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['cookie']
    },
    backend: {
      loadPath: '/assets/locales/{{lng}}/{{ns}}.json',
    }
  })
  // Namespaces load on demand, and a component asking for one that is missing suspends the whole app
  // (full-page loader flash). Fetching them all in the background avoids that when a modal opens.
  .then(() => i18n.loadNamespaces(ALL_NAMESPACES));

// Rendering Maintenance instead of App keeps the app from calling the API during an upgrade.
// Opening ?preview=<REACT_APP_MAINTENANCE_PREVIEW_KEY> lets a tester bypass it in their own browser
// (kept in localStorage so OAuth redirects, which drop the query string, still work). ?preview=off clears it.
// This only hides the maintenance screen; it is not an access control.
const PREVIEW_STORAGE_KEY = 'maintenance_preview';
const isPreviewBypass = () => {
  const previewKey = process.env.REACT_APP_MAINTENANCE_PREVIEW_KEY;
  if (!previewKey) return false;
  try {
    const param = new URLSearchParams(window.location.search).get('preview');
    if (param === 'off') localStorage.removeItem(PREVIEW_STORAGE_KEY);
    else if (param === previewKey) localStorage.setItem(PREVIEW_STORAGE_KEY, previewKey);
    return localStorage.getItem(PREVIEW_STORAGE_KEY) === previewKey;
  } catch (e) {
    return false;
  }
};
const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true' && !isPreviewBypass();

ReactDOM.render(
  <Suspense fallback={<Loader />}>
    <React.StrictMode>
      {MAINTENANCE_MODE ? <Maintenance /> : <App />}
    </React.StrictMode>
  </Suspense>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
